module.exports = {
  // Export
  exportAsPng: 'Export as PNG',
  exportError: 'Failed to export flow diagram',

  // Common actions
  addStep: 'Add Step',
  addCase: 'Add Case',
  addBranch: 'Add Branch',

  // Loop nodes
  noStepsInLoop: 'No steps in loop',

  // IF node branches
  trueBranch: 'True',
  falseBranch: 'False',

  // Switch node
  pleaseAddCaseAndStep: 'Please add case and step',
  noStepsInCase: 'No steps in case',
  caseName: 'Case name',
  caseCondition: "Condition (e.g., $.value == 'x' or 'else')",
  case: 'Case',
  defaultCase: 'Default (else)',
  editCases: 'Edit Cases',

  // Delete confirmation dialog
  confirmDeleteTitle: 'Confirm Delete',
  confirmDeleteMessage: 'Do you really want to delete',
  confirmDeleteWarning: 'This action cannot be undone.',
  cancelButton: 'Cancel',
  deleteButton: 'Delete',
  discardButton: 'Discard',
  deleteCaseConfirmTitle: 'Delete Case',
  deleteCaseConfirmMessage: 'This case contains %n% step(s). Are you sure you want to delete it?',

  // Error messages
  stepNotFound: 'Step not found. The flow may have changed.',
  flowNotFound: 'Flow not found or you do not have permission to access it.',
  operationFailed: 'Operation failed. Please try again.',
  ifConditionRequired: 'IF step "%name%" requires a condition.',
  multipleIfConditionsRequired: '%count% IF steps are missing required conditions.',

  // Condition edit modal
  editCondition: 'Edit Condition',
  viewCondition: 'View Condition',
  conditionRequired: 'Condition is required',
  conditionTooLong: 'Condition must be 2000 characters or less',
  nameTooLong: 'Name must be 250 characters or less',

  // ForEach edit modal
  editForEach: 'Edit ForEach Step',
  viewForEach: 'View ForEach Step',
  collectionExpression: 'Collection to iterate',
  itemVariableName: 'Item variable name',
  indexVariableName: 'Index variable name (optional)',
  preview: 'Preview',
  collectionRequired: 'Collection is required',
  itemVarRequired: 'Item variable name is required',
  invalidIdentifier: 'Must be a valid JavaScript identifier',

  // Field edit modal
  editField: 'Edit Field Step',
  viewField: 'View Field Step',
  actionLabel: 'Action',
  fieldIdLabel: 'Field ID',
  valueLabel: 'Value',
  targetObjectLabel: 'Target Variable',
  targetObjectRequired: 'Target variable is required',
  targetObjectInvalidPattern: 'Must be a valid path (e.g., $.foo.bar or $.result)',
  cssClassesLabel: 'CSS Classes',
  cssClassesHint: 'Enter CSS class names separated by commas',
  cssClassesRequired: 'At least one CSS class is required',
  cssClassesTooLong: 'CSS classes must be 500 characters or less',
  actionRequired: 'Action is required',
  fieldIdRequired: 'Field ID is required',
  valueTooLong: 'Value must be 2000 characters or less',

  // Field actions
  fieldActions: {
    SHOW: 'Show',
    HIDE: 'Hide',
    SET_VALUE: 'Set Value',
    GET_VALUE: 'Get Value',
    ADD_CSS_CLASS: 'Add CSS Class',
    REMOVE_CSS_CLASS: 'Remove CSS Class'
  },

  // Field summary prefixes (for node display)
  fieldSummary: {
    set: 'SET',
    get: 'GET',
    addCss: '+CSS',
    removeCss: '-CSS'
  },

  // Debug edit modal
  editDebug: 'Edit Debug Step',
  viewDebug: 'View Debug Step',
  levelLabel: 'Level',
  messageLabel: 'Message',
  messageRequired: 'Message is required',
  messageTooLong: 'Message must be 2000 characters or less',

  // Debug enabled/disabled
  stepEnabled: 'Step Enabled',
  stepDisabledHint: 'This step is disabled and will be skipped during execution',

  // Debug data expressions
  dataExpressionsLabel: 'Data Expressions',
  addExpression: 'Add Expression',
  noDataExpressions: 'No data expressions. Add expressions to print additional values during logging.',
  maxDataExpressions: 'Maximum 20 expressions allowed',
  dataExpressionPlaceholder: '$.fieldName',
  expressionCount: '{count} expression(s)',

  // Open step modal
  editOpen: 'Edit Open Step',
  viewOpen: 'View Open Step',
  targetUrlLabel: 'Target URL or Screen',
  targetUrlRequired: 'Target URL is required',

  // Open step modal - enhanced (new keys for full API support)
  openTargetTypeLabel: 'Target Type',
  openTargetTypeRequired: 'Target type is required',
  openUrlLabel: 'URL',
  openUrlHint: 'URL to open (supports JSONPath expressions like $.vars.url)',
  openUrlRequired: 'URL is required',
  openModeLabel: 'Tab Mode',
  openModeHint: 'Whether to open in same tab or new tab',
  openScreenLabel: 'Screen',
  openScreenHint: 'Search for a screen by name',
  screenNotFound: 'Screen not found. The screen may have been deleted or you may not have permission to access it.',

  // Open step options
  openTargetTypes: {
    URL: 'URL',
    SCREEN: 'Screen'
  },
  openModes: {
    SAME_TAB: 'Same Tab',
    NEW_TAB: 'New Tab'
  },

  // Scroll step modal
  editScroll: 'Edit Scroll Step',
  viewScroll: 'View Scroll Step',
  scrollTargetTypeLabel: 'Target Type',
  scrollTargetTypeRequired: 'Target type is required',
  scrollFieldIdLabel: 'Target Element ID',
  scrollFieldIdHint: 'JSONPath expression for the element to scroll to',
  scrollFieldIdRequired: 'Target element ID is required',
  scrollYPositionLabel: 'Y Position (pixels)',
  scrollYPositionHint: 'Vertical scroll position in pixels',
  scrollYPositionRequired: 'Y position is required for POSITION target type',
  scrollYPositionInvalid: 'Y position must be between 0 and 10000000',
  scrollBehaviorLabel: 'Scroll Behavior',
  scrollAlignmentLabel: 'Alignment',
  scrollAlignmentHint: 'How the target should be aligned in the viewport',
  scrollOffsetLabel: 'Offset (pixels)',
  scrollOffsetHint: 'Additional offset after scrolling (e.g., for sticky headers)',
  scrollOffsetInvalid: 'Offset must be between -10000 and 10000',

  // Scroll step options
  scrollTargetTypes: {
    FIELD: 'Field',
    POSITION: 'Position'
  },
  scrollBehaviors: {
    AUTO: 'Auto',
    SMOOTH: 'Smooth'
  },
  scrollAlignments: {
    START: 'Start',
    CENTER: 'Center',
    END: 'End',
    NEAREST: 'Nearest'
  },

  // Modal step modal
  editModal: 'Edit Modal Step',
  viewModal: 'View Modal Step',
  modalActionLabel: 'Action',
  modalActionRequired: 'Action is required',
  modalScreenLabel: 'Screen',
  modalScreenHint: 'Search for a screen by name',

  // Modal step actions
  modalActions: {
    OPEN: 'Open',
    CLOSE: 'Close'
  },

  // Notification step modal
  editNotification: 'Edit Notification Step',
  viewNotification: 'View Notification Step',
  notificationTypeRequired: 'Notification type is required',
  notificationMessageRequired: 'Notification message is required',

  // Notification step modal - new labels
  notificationTitleLabel: 'Notification Title',
  notificationTitleHint: 'Optional title displayed above the message',
  notificationLevelLabel: 'Notification Level',
  notificationLevelRequired: 'Notification level is required',
  notificationDurationLabel: 'Duration (ms)',
  notificationDurationHint: 'How long the notification stays visible (0 = sticky, max 600000)',
  notificationDurationInvalid: 'Duration must be between 0 and 600000 milliseconds',
  notificationDismissibleLabel: 'Dismissible',
  noDataExpressionsNotification: 'No data expressions. Add expressions to include additional data in the notification.',

  // Error step modal
  editError: 'Edit Error Step',
  viewError: 'View Error Step',
  errorMessageLabel: 'Error Message',
  errorMessageRequired: 'Error message is required',

  // Error step modal - enhanced (new keys for details support)
  errorDetailsLabel: 'Error Details',
  noErrorDetails: 'No error details. Add expressions to include additional context in the error.',
  maxErrorDetails: 'Maximum 20 detail expressions allowed',

  // JavaScript step modal - titles
  editJs: 'Edit JavaScript Step',
  viewJs: 'View JavaScript Step',

  // JavaScript step modal - labels
  scriptLabel: 'Script',
  scriptPlaceholder: 'const result = input.value * 2;\nreturn { result };',
  inputMappingsLabel: 'Input Mappings',
  inputKeyLabel: 'Variable Name',
  inputValueLabel: 'Value Expression',
  addInputMapping: 'Add Mapping',
  removeInputMapping: 'Remove mapping',
  resultPathLabel: 'Result Path',
  resultPathHint: 'JSONPath where the script result is stored (e.g., $.vars.jsResult)',
  timeoutMsLabel: 'Timeout (ms)',
  timeoutMsHint: 'Execution timeout in milliseconds (50-30000)',
  noInputMappings: 'No input mappings defined. Variables can be accessed via the input object.',

  // JavaScript step modal - validation messages
  scriptRequired: 'Script is required',
  scriptTooLong: 'Script must be 50000 characters or less',
  inputKeyRequired: 'Variable name is required',
  inputKeyInvalid: 'Must be a valid JavaScript identifier (letters, numbers, underscore, dollar sign)',
  inputKeyDuplicate: 'Variable name must be unique',
  inputValueTooLong: 'Value expression must be 2000 characters or less',
  maxInputMappings: 'Maximum 50 input mappings allowed',
  resultPathInvalid: 'Must be a valid JSONPath (e.g., $.vars.result)',
  timeoutMsOutOfRange: 'Timeout must be between 50 and 30000 milliseconds',

  // Execute Flow step modal
  editExecuteFlow: 'Edit Execute Flow Step',
  viewExecuteFlow: 'View Execute Flow Step',
  processRequired: 'Process is required',
  flowRequired: 'Flow is required',
  inputMappings: 'Input Mappings',
  outputMappings: 'Output Mappings',
  inputField: 'Input Field',
  outputField: 'Output Field',
  expression: 'Expression',
  required: 'Required',
  noInputsRequired: 'No input fields defined for this process',
  noOutputsDefined: 'No output fields defined for this process',
  childEventIdPathHint: 'Optional: Store the child process event ID in this variable',

  // Execution modes
  executionModes: {
    SYNCHRONOUS: 'Synchronous (wait for completion)',
    ASYNCHRONOUS: 'Asynchronous (fire and forget)',
    INLINE: 'Inline (execute in same context)'
  },
  timeout: 'Timeout (ms)',
  timeoutHint: 'Maximum wait time for synchronous execution (default: 30 seconds)',
  timeoutMinimum: 'Timeout must be at least 1ms',

  // Step sections
  sections: {
    controlFlow: 'Control Flow',
    field: 'Field',
    uiFeedback: 'UI Feedback',
    navigation: 'Navigation',
    orchestration: 'Orchestration',
    debug: 'Debug',
    scripting: 'Scripting'
  },

  // Step types
  stepTypes: {
    start: 'Start',
    end: 'End',
    if: 'If',
    switch: 'Switch',
    while: 'While',
    doWhile: 'Do While',
    forEach: 'For Each',
    field: 'Field',
    notification: 'Notification',
    error: 'Error',
    scroll: 'Scroll',
    open: 'Open',
    modal: 'Modal',
    debug: 'Debug',
    executeFlow: 'Execute Flow',
    js: 'JavaScript'
  }
}
